module.exports = __webpack_public_path__ + "static/media/Videos.86b98d0a.webp";